export default __webpack_public_path__ + "static/media/2.1874ec4f.JPG";